import Bowser from 'bowser'

const dataBrowser = [
	{ subString: 'Edge' },
	{ subString: 'Chrome' },
	{ subString: '.NET' },
	{ subString: 'Firefox' },
	{ subString: 'iPad' },
	{ subString: 'Macintosh' },
	{ subString: 'iPhone' }
]

class Browser {
	static getBrowser() {
		return dataBrowser.filter(
			browser => navigator.userAgent.indexOf(browser.subString) !== -1
		)
	}

	static isIE() {
		
		return Browser.getBrowser()[0].subString === '.NET'
	}

	static isInternetExplorer() {
		const browser = Bowser.getParser(window.navigator.userAgent)
		
		return browser.getBrowser().name === 'Internet Explorer'
	}

	static isEdge() {
		return Browser.getBrowser()[0].subString === 'Edge'
	}

	static isiPad() {
		return Browser.getBrowser()[0].subString === 'iPad'
	}

	static isSafari() {
		return Browser.getBrowser()[0].subString === 'Macintosh'
	}

	static isFirefox() {
		return Browser.getBrowser()[0].subString === 'Firefox'
	}

	static isiPhone() {
		return Browser.getBrowser()[0].subString === 'iPhone'
	}
}

export default Browser
